





























































































import Aircraft from '@/store/entities/flight/aircraft';
import { Component, Vue } from 'vue-property-decorator';
import AddAircraftType from './modals/addAircraftType.vue';

@Component({
  components: { AddAircraftType },
})
export default class AircraftTypes extends Vue {
  search: string = '';
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  aircrafts: Aircraft[] = [];

  created() {
    this.getAircraft();

    (this.headers = [
      { text: 'Şirket', value: 'company' },
      { text: 'Toplam Koltuk', value: 'seat' },
      { text: 'Maksimum Bagaj', value: 'baggage' },
      { text: 'Model', value: 'model' },
      { text: 'Notlar', value: 'notes' },
      { text: 'Uçak Adı', value: 'name' },
      { text: 'İşlemler', value: 'transactions' },
    ]),
      (this.mockData = [
        {
          company: 'Boeing',
          seat: 144,
          baggage: 20,
          model: 'B 737-490',
          notes: '',
          name: 'Boeing B 737-490',
        },
      ]);

    this.breadcrumbsItems = [
      { text: 'Ana Sayfa', disabled: false, href: '/#/main/home' },
      { text: 'Tanımlamalar', disabled: true },
      { text: 'Uçak Tipleri', disabled: true },
    ];
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

  async getAircraft() {
    await this.$store.dispatch({
      type: 'aircraft/getAircraft',
    });

    this.aircrafts = this.$store.state.aircraft.list;
  }

  editAircraft(item) {
    this.$store.state.aircraft.editAircraft = item;
    this.isOpenModal = true;
  }

  async deleteAircraft(item) {

    await this.$store
      .dispatch({
        type: 'aircraft/deleteAircraft',
        payload: item.id,
      })
      .then((x) => {
        this.getAircraft();
      });
  }

  confirmDelete(item) {
    this.$swal({
      title: 'Satır Silinecetir.',
      text: 'İşlemi Devam Ettirmeye Emin misiniz?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet',
      cancelButtonText: 'Hayır',
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteAircraft(item);
        Vue.$toast.success('Silme Başarılı');
      }
    });
  }

  openModal() {
    this.$store.state.aircraft.editAircraft = null;
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getAircraft();
  }

  cancelModal() {
    this.isOpenModal = false;
  }
}
